module.exports = __webpack_public_path__ + "97138db633db9c0b8492e9387afe5530.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logos/MainLogo/logo.png
// module id = 632
// module chunks = 0